import { render, staticRenderFns } from "./Suitforadd.vue?vue&type=template&id=8ac546e4&scoped=true"
import script from "./Suitforadd.vue?vue&type=script&lang=js"
export * from "./Suitforadd.vue?vue&type=script&lang=js"
import style0 from "./Suitforadd.vue?vue&type=style&index=0&id=8ac546e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac546e4",
  null
  
)

export default component.exports